const SOB_BOX_STORAGE_KEY = "sob_cart_box_v1";
const SOB_BOX_EDIT_FLAG_KEY = "sob_cart_box_edit_mode";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".sob-box-builder").forEach(initBoxBuilder);
  initSobLightbox();
});

function safeStorageGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

function safeStorageSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (error) {
    return false;
  }
}

function safeStorageRemove(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    // no-op
  }
}

function validateStoredBoxPayload(payload) {
  if (!payload || typeof payload !== "object") return false;
  if (payload.version !== 1) return false;
  if (!Array.isArray(payload.items) || !payload.items.length) return false;
  if (typeof payload.id !== "string" || !payload.id) return false;
  if (typeof payload.configUrl !== "string" || !payload.configUrl) return false;

  return payload.items.every((item) => {
    return (
      item &&
      Number.isFinite(Number(item.variantId)) &&
      Number(item.variantId) > 0 &&
      Number.isFinite(Number(item.qty)) &&
      Number(item.qty) > 0 &&
      (item.role === "meal" || item.role === "extra")
    );
  });
}

function saveCurrentBoxToStorage(payload) {
  if (!validateStoredBoxPayload(payload)) return false;
  return safeStorageSet(SOB_BOX_STORAGE_KEY, JSON.stringify(payload));
}

function enableBoxEditMode() {
  return safeStorageSet(SOB_BOX_EDIT_FLAG_KEY, "1");
}

function disableBoxEditMode() {
  safeStorageRemove(SOB_BOX_EDIT_FLAG_KEY);
}

function buildStoredBoxPayload({
  boxId,
  boxLabel,
  configUrl,
  planLabel,
  min,
  max,
  totalMeals,
  meals,
  extras
}) {
  const items = [];

  meals.forEach((item) => {
    items.push({
      variantId: Number(item.id),
      qty: Number(item.qty),
      title: String(item.title || ""),
      role: "meal",
      extraKind: ""
    });
  });

  extras.forEach((item) => {
    items.push({
      variantId: Number(item.id),
      qty: Number(item.qty),
      title: String(item.title || ""),
      role: "extra",
      extraKind: String(item.extraKind || "")
    });
  });

  return {
    version: 1,
    id: String(boxId),
    label: String(boxLabel || ""),
    configUrl: String(configUrl || window.location.pathname + window.location.search),
    planLabel: String(planLabel || "Achat unique — sans abonnement"),
    min: Number(min || 0),
    max: Number(max || 0),
    totalMeals: Number(totalMeals || 0),
    createdAt: Date.now(),
    items: items
  };
}

async function clearEntireCart() {
  const response = await fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Accept": "application/json"
    }
  });

  if (!response.ok) {
    throw new Error("Erreur vidage panier");
  }
}

function initBoxBuilder(root) {
  const min = Number(root.dataset.min || 1);
  const max = Number(root.dataset.max || 1);
  const variantId = Number(root.dataset.variant || 0);
  const boxTitle = root.dataset.title || "Box So'Bneen";
  const pricingMode = root.dataset.pricingMode || "fixed_box";

  const sellingPlanSelect = root.querySelector("[data-selling-plan]");
  const countNode = root.querySelector("[data-count]");
  const listMeals = root.querySelector("[data-meals]");
  const listExtras = root.querySelector("[data-extras]");
  const submitBtn = root.querySelector("[data-submit]");
  const messageNode = root.querySelector("[data-message]");
  const progressBar = root.querySelector("[data-progress]");
  const planLabelNode = root.querySelector("[data-plan-label]");
  const scrollToPlanBtn = root.querySelector("[data-scroll-to-plan]");

  const mobileCountNode = root.querySelector("[data-mobile-count]");
  const mobileDrawerCountNode = root.querySelector("[data-mobile-drawer-count]");
  const mobileProgressBar = root.querySelector("[data-mobile-progress]");
  const mobilePlanLabel = root.querySelector("[data-mobile-plan-label]");
  const mobileMeals = root.querySelector("[data-mobile-meals]");
  const mobileExtras = root.querySelector("[data-mobile-extras]");
  const mobileSubmitBtn = root.querySelector("[data-mobile-submit]");
  const mobileDrawer = root.querySelector("[data-mobile-drawer]");
  const mobileToggleBtn = root.querySelector("[data-mobile-summary-toggle]");
  const mobileCloseBtns = root.querySelectorAll("[data-mobile-summary-close]");
  const scrollToPlanMobileBtn = root.querySelector("[data-scroll-to-plan-mobile]");

  const meals = new Map();
  const extras = new Map();

  initSectionsNav(root);

  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get("sob_recompose") === "1") {
    enableBoxEditMode();
  } else {
    disableBoxEditMode();
  }

  if (pricingMode === "fixed_box" && !variantId) {
    if (submitBtn) submitBtn.disabled = true;
    if (mobileSubmitBtn) mobileSubmitBtn.disabled = true;
    if (messageNode) messageNode.textContent = "Produit box non configuré.";
    return;
  }

  if (scrollToPlanBtn && sellingPlanSelect) {
    scrollToPlanBtn.addEventListener("click", () => {
      sellingPlanSelect.scrollIntoView({ behavior: "smooth", block: "center" });
      sellingPlanSelect.focus();
    });
  }

  if (scrollToPlanMobileBtn && sellingPlanSelect) {
    scrollToPlanMobileBtn.addEventListener("click", () => {
      closeMobileDrawer();
      sellingPlanSelect.scrollIntoView({ behavior: "smooth", block: "center" });
      sellingPlanSelect.focus();
    });
  }

  if (sellingPlanSelect) {
    sellingPlanSelect.addEventListener("change", updatePlanLabel);
  }

  if (mobileToggleBtn) {
    mobileToggleBtn.addEventListener("click", () => {
      if (mobileDrawer && mobileDrawer.hasAttribute("hidden")) {
        openMobileDrawer();
      } else {
        closeMobileDrawer();
      }
    });
  }

  mobileCloseBtns.forEach((btn) => {
    btn.addEventListener("click", closeMobileDrawer);
  });

  root.addEventListener("click", (event) => {
    const navButton = event.target.closest("[data-nav-target]");
    if (navButton) {
      const target = document.getElementById(navButton.dataset.navTarget);
      if (target) {
        const headerHeight =
          document.querySelector(".shopify-section-header")?.offsetHeight || 120;
        const isMobile = window.innerWidth <= 990;
        const offset = isMobile
          ? Math.max(headerHeight, 92)
          : Math.max(headerHeight + 20, 140);
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
      return;
    }

    const galleryViewBtn = event.target.closest("[data-gallery-view]");
    if (galleryViewBtn) {
      const card = galleryViewBtn.closest(".sob-card");
      const gallery = card ? card.querySelector("[data-gallery]") : null;
      if (gallery) {
        const startIndex = Math.max(
          Number(galleryViewBtn.dataset.galleryView || 1) - 1,
          0
        );
        openSobGallery(gallery, startIndex);
      }
      return;
    }

    const gallery = event.target.closest("[data-gallery]");
    if (gallery && !event.target.closest("button")) {
      openSobGallery(gallery, 0);
      return;
    }

    const plusBtn = event.target.closest("[data-plus]");
    const minusBtn = event.target.closest("[data-minus]");
    const summaryActionBtn = event.target.closest("[data-summary-action]");

    if (summaryActionBtn) {
      const type = summaryActionBtn.dataset.summaryType;
      const id = summaryActionBtn.dataset.summaryId;
      const action = summaryActionBtn.dataset.summaryAction;
      const store = type === "extra" ? extras : meals;
      const item = store.get(id);

      if (!item) return;

      if (action === "plus") {
        if (type === "meal" && getMealCount() >= max) {
          setMessage("Ajuster la quantité du panier");
          render();
          return;
        }
        item.qty += 1;
        store.set(id, item);
      }

      if (action === "minus") {
        item.qty -= 1;
        if (item.qty <= 0) {
          store.delete(id);
        } else {
          store.set(id, item);
        }
      }

      if (action === "remove") {
        store.delete(id);
      }

      render();
      return;
    }

    if (!plusBtn && !minusBtn) return;

    const card = event.target.closest(".sob-card");
    if (!card) return;

    const type = card.dataset.type;
    const id = card.dataset.id;
    const title = card.dataset.title;
    const price = card.dataset.price || "";
    const extraKind = card.dataset.extraKind || "";
    const store = type === "extra" ? extras : meals;

    const current = store.get(id) || {
      id: id,
      title: title,
      price: price,
      qty: 0,
      extraKind: extraKind
    };

    if (plusBtn) {
      if (type === "meal" && getMealCount() >= max) {
        setMessage("Ajuster la quantité du panier");
        render();
        return;
      }
      current.qty += 1;
      store.set(id, current);
    }

    if (minusBtn) {
      current.qty -= 1;
      if (current.qty <= 0) {
        store.delete(id);
      } else {
        store.set(id, current);
      }
    }

    render();
  });

  if (submitBtn) {
    submitBtn.addEventListener("click", addToCart);
  }

  if (mobileSubmitBtn) {
    mobileSubmitBtn.addEventListener("click", addToCart);
  }

  async function addToCart() {
    const totalMeals = getMealCount();

    if (totalMeals < min || totalMeals > max) {
      setMessage("Ajuster la quantité du panier");
      render();
      return;
    }

    setLoadingState(true);

    try {
      await clearEntireCart();
      await addSelectedItemsToCart();

      const boxGroupId = buildBoxGroupId();
      const boxLabel = buildBoxLabel(totalMeals);

      const cleanedUrl = new URL(window.location.href);
      cleanedUrl.searchParams.delete("sob_recompose");
      const configUrl = cleanedUrl.pathname + cleanedUrl.search;

      const selectedPlanLabel = getSelectedPlanLabel();

      const payload = buildStoredBoxPayload({
        boxId: boxGroupId,
        boxLabel: boxLabel,
        configUrl: configUrl,
        planLabel: selectedPlanLabel,
        min: min,
        max: max,
        totalMeals: totalMeals,
        meals: meals,
        extras: extras
      });

      saveCurrentBoxToStorage(payload);
      disableBoxEditMode();

      window.location.href = "/cart";
    } catch (error) {
      console.error(error);
      setLoadingState(false);
      setMessage("Une erreur s'est produite. Veuillez réessayer.");
      renderButtonState();
    }
  }

  async function addSelectedItemsToCart() {
    const items = [];
    const selectedPlanId = getSelectedPlanId();

    meals.forEach((item) => {
      const payload = {
        id: Number(item.id),
        quantity: item.qty
      };

      if (selectedPlanId) {
        payload.selling_plan = selectedPlanId;
      }

      items.push(payload);
    });

    extras.forEach((item) => {
      items.push({
        id: Number(item.id),
        quantity: item.qty
      });
    });

    if (!items.length) {
      throw new Error("Aucun article à ajouter");
    }

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      throw new Error("Erreur ajout panier");
    }
  }

  function setLoadingState(isLoading) {
    if (submitBtn) {
      submitBtn.disabled = isLoading;
      submitBtn.textContent = isLoading ? "Ajout en cours..." : submitBtn.textContent;
    }

    if (mobileSubmitBtn) {
      mobileSubmitBtn.disabled = isLoading;
      mobileSubmitBtn.textContent = isLoading ? "Ajout en cours..." : mobileSubmitBtn.textContent;
    }
  }

  function buildBoxGroupId() {
    return "SOBBOX-" + Date.now() + "-" + Math.floor(Math.random() * 100000);
  }

  function buildBoxLabel(totalMeals) {
    return "🟢 " + boxTitle + " – " + totalMeals + " repas";
  }

  function getSelectedPlanId() {
    if (!sellingPlanSelect || !sellingPlanSelect.value) return null;
    return Number(sellingPlanSelect.value);
  }

  function openMobileDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.removeAttribute("hidden");
    document.documentElement.classList.add("sob-no-scroll");
  }

  function closeMobileDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.setAttribute("hidden", "");
    document.documentElement.classList.remove("sob-no-scroll");
  }

  function getMealCount() {
    let total = 0;
    meals.forEach((item) => {
      total += item.qty;
    });
    return total;
  }

  function getSelectedPlanLabel() {
    if (!sellingPlanSelect) return "Achat unique — sans abonnement";
    const selectedOption = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
    return selectedOption
      ? selectedOption.textContent.trim()
      : "Achat unique — sans abonnement";
  }

  function updatePlanLabel() {
    const label = getSelectedPlanLabel();
    if (planLabelNode) planLabelNode.textContent = label;
    if (mobilePlanLabel) mobilePlanLabel.textContent = label;
  }

  function shortenTitle(str, maxLength = 42) {
    const value = String(str || "");
    return value.length > maxLength ? value.slice(0, maxLength - 1) + "…" : value;
  }

  function render() {
    root.querySelectorAll(".sob-card").forEach((card) => {
      const type = card.dataset.type;
      const id = card.dataset.id;
      const store = type === "extra" ? extras : meals;
      const qtyNode = card.querySelector("[data-qty]");
      const qty = store.get(id) ? store.get(id).qty : 0;

      if (qtyNode) {
        qtyNode.textContent = qty;
      }
    });

    const totalMeals = getMealCount();
    const progressWidth = Math.min((totalMeals / max) * 100, 100) + "%";

    if (countNode) countNode.textContent = totalMeals;
    if (mobileCountNode) mobileCountNode.textContent = totalMeals;
    if (mobileDrawerCountNode) mobileDrawerCountNode.textContent = totalMeals;

    if (progressBar) progressBar.style.width = progressWidth;
    if (mobileProgressBar) mobileProgressBar.style.width = progressWidth;

    renderList(listMeals, meals, false, "meal");
    renderList(listExtras, extras, true, "extra");
    renderList(mobileMeals, meals, false, "meal");
    renderList(mobileExtras, extras, true, "extra");

    renderButtonState();
    updatePlanLabel();
    toggleDessertSuggestion();

    if (totalMeals >= min && totalMeals <= max) {
      root.classList.add("sob-box-ready");
    } else {
      root.classList.remove("sob-box-ready");
    }
  }

  function renderList(container, map, showPrice, type) {
    if (!container) return;

    if (map.size === 0) {
      container.innerHTML = "<p class='sob-empty-line'>Aucun</p>";
      return;
    }

    let html = "";

    map.forEach((item) => {
      html +=
        '<div class="sob-summary-row">' +
          '<div class="sob-summary-main">' +
            '<div class="sob-summary-title" title="' + escapeHtml(item.title) + '">' +
              escapeHtml(shortenTitle(item.title)) +
            "</div>" +
            (showPrice
              ? '<div class="sob-summary-price">' + escapeHtml(item.price || "") + "</div>"
              : "") +
          "</div>" +
          '<div class="sob-summary-actions">' +
            '<button type="button" class="sob-mini-btn" data-summary-action="minus" data-summary-type="' + type + '" data-summary-id="' + item.id + '">−</button>' +
            '<span class="sob-summary-qty">' + item.qty + "</span>" +
            '<button type="button" class="sob-mini-btn" data-summary-action="plus" data-summary-type="' + type + '" data-summary-id="' + item.id + '">+</button>' +
            '<button type="button" class="sob-remove-btn" data-summary-action="remove" data-summary-type="' + type + '" data-summary-id="' + item.id + '">×</button>' +
          "</div>" +
        "</div>";
    });

    container.innerHTML = html;
  }

  function renderButtonState() {
    const totalMeals = getMealCount();
    const valid = totalMeals >= min && totalMeals <= max;

    const readyText = "Commander ma box";
    const notReadyText = "Complétez votre Box";

    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = valid ? readyText : notReadyText;
    }

    if (mobileSubmitBtn) {
      mobileSubmitBtn.disabled = false;
      mobileSubmitBtn.textContent = valid ? readyText : notReadyText;
    }

    if (valid) {
      setMessage("Votre box est prête.");
      if (submitBtn) submitBtn.classList.add("is-ready");
      if (mobileSubmitBtn) mobileSubmitBtn.classList.add("is-ready");
    } else {
      setMessage("Complétez votre Box");
      if (submitBtn) submitBtn.classList.remove("is-ready");
      if (mobileSubmitBtn) mobileSubmitBtn.classList.remove("is-ready");
    }
  }

  function toggleDessertSuggestion() {
    const footer = root.querySelector(".sob-summary-footer");
    if (!footer) return;

    let suggestion = footer.querySelector(".sob-dessert-suggestion");

    const isBoxFull = getMealCount() === max;
    const hasDessert = Array.from(extras.values()).some((item) => item.extraKind === "dessert");

    if (isBoxFull && !hasDessert && !suggestion) {
      suggestion = document.createElement("div");
      suggestion.className = "sob-dessert-suggestion";
      suggestion.innerHTML =
        '<h4>🍰 Et une petite gourmandise ?</h4>' +
        "<p>Votre box est prête. Vous pouvez ajouter un dessert pour compléter votre expérience.</p>" +
        '<div class="sob-dessert-suggestion-actions">' +
          '<button type="button" class="sob-dessert-link-btn" data-nav-target="sob-section-desserts">Voir les desserts</button>' +
        "</div>";

      const submitButton = footer.querySelector("[data-submit]");
      if (submitButton) {
        footer.insertBefore(suggestion, submitButton);
      } else {
        footer.appendChild(suggestion);
      }
    }

    if ((!isBoxFull || hasDessert) && suggestion) {
      suggestion.remove();
    }
  }

  function setMessage(text) {
    if (messageNode) {
      messageNode.textContent = text;
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  render();
}

function initSectionsNav(root) {
  const nav = root.querySelector("[data-sections-nav]");
  if (!nav) return;

  const buttons = Array.from(nav.querySelectorAll("[data-nav-target]"));
  const sections = buttons
    .map((button) => document.getElementById(button.dataset.navTarget))
    .filter(Boolean);

  if (!buttons.length || !sections.length) return;

  const updateActiveButton = () => {
    const isMobile = window.innerWidth <= 990;
    const offset = isMobile ? 120 : 170;
    let currentId = sections[0].id;

    sections.forEach((section) => {
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      if (window.scrollY + offset >= sectionTop) {
        currentId = section.id;
      }
    });

    buttons.forEach((button) => {
      button.classList.toggle("is-active", button.dataset.navTarget === currentId);
    });
  };

  window.addEventListener("scroll", updateActiveButton, { passive: true });
  window.addEventListener("resize", updateActiveButton);
  updateActiveButton();
}

let sobGalleryState = {
  images: [],
  index: 0,
  title: ""
};

function initSobLightbox() {
  if (document.querySelector(".sob-lightbox")) return;

  const lightbox = document.createElement("div");
  lightbox.className = "sob-lightbox";
  lightbox.innerHTML =
    '<div class="sob-lightbox-inner">' +
      '<button type="button" class="sob-lightbox-btn" data-lightbox-prev>‹</button>' +
      '<div class="sob-lightbox-media"><img src="" alt=""></div>' +
      '<button type="button" class="sob-lightbox-btn" data-lightbox-next>›</button>' +
      '<button type="button" class="sob-lightbox-close" data-lightbox-close>×</button>' +
    "</div>";

  document.body.appendChild(lightbox);

  lightbox.addEventListener("click", (event) => {
    if (event.target === lightbox || event.target.closest("[data-lightbox-close]")) {
      closeSobGallery();
    }
    if (event.target.closest("[data-lightbox-prev]")) {
      changeSobGallery(-1);
    }
    if (event.target.closest("[data-lightbox-next]")) {
      changeSobGallery(1);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (!lightbox.classList.contains("is-open")) return;
    if (event.key === "Escape") closeSobGallery();
    if (event.key === "ArrowLeft") changeSobGallery(-1);
    if (event.key === "ArrowRight") changeSobGallery(1);
  });
}

function openSobGallery(element, startIndex = 0) {
  const images = [
    element.getAttribute("data-image-1"),
    element.getAttribute("data-image-2"),
    element.getAttribute("data-image-3")
  ].filter(Boolean);

  if (!images.length) return;

  let safeIndex = startIndex;
  if (safeIndex >= images.length) safeIndex = images.length - 1;
  if (safeIndex < 0) safeIndex = 0;

  sobGalleryState = {
    images: images,
    index: safeIndex,
    title: element.getAttribute("data-gallery-title") || ""
  };

  const lightbox = document.querySelector(".sob-lightbox");
  if (!lightbox) return;

  lightbox.classList.add("is-open");
  renderSobGallery();
}

function changeSobGallery(direction) {
  if (!sobGalleryState.images.length) return;

  sobGalleryState.index =
    (sobGalleryState.index + direction + sobGalleryState.images.length) %
    sobGalleryState.images.length;

  renderSobGallery();
}

function renderSobGallery() {
  const lightbox = document.querySelector(".sob-lightbox");
  if (!lightbox) return;

  const img = lightbox.querySelector(".sob-lightbox-media img");
  const current = sobGalleryState.images[sobGalleryState.index];

  img.src = current;
  img.alt = sobGalleryState.title || "";
}

function closeSobGallery() {
  const lightbox = document.querySelector(".sob-lightbox");
  if (!lightbox) return;
  lightbox.classList.remove("is-open");
}